import React from 'react'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

import Button from '../../atoms/Button/Button'

const ResetButtonLink = ({ items, refine, onClick, ...props }) => (
  <Button type='white' onClick={() => refine(items)} {...props}>
    <u>Reset filters</u>
  </Button>
)

export default connectCurrentRefinements(ResetButtonLink)
